import { directoryActiveViewResource, directoryFavoriteViewsResource } from '@townsquare/directory-header/resources';
import Loadable from '@townsquare/loadable';
import { onboardingResource } from '@townsquare/onboarding/resource';
import {
  projectDirectoryArchivedRoute,
  projectDirectoryFollowingRoute,
  projectDirectoryRoute,
  projectNoWorkspaceDirectoryRoute,
} from '@townsquare/routes/project-directory-view';
import { titanEapCrossFlowQueryResource } from '@townsquare/titan-eap-cross-flow/resource';
import { tqlExplainerResource } from '@townsquare/tql/resource';

import { ProjectsEmptyOrNonProvisionedState } from './components/EmptyOrNonProvisionedState';
import { projectDirectoryResource } from './resources/project-directory';
import { projectDirectoryViewResource } from './resources/project-directory-view';

// Project Directory View
const ProjectDirectoryLoadable = Loadable({
  loader: () => import(/* webpackChunkName: "project-view" */ './components/ProjectDirectory'),
  loading: () => null,
});

projectDirectoryRoute.component = ProjectDirectoryLoadable;
projectDirectoryRoute.resources = [
  onboardingResource,
  projectDirectoryResource,
  projectDirectoryViewResource,
  directoryFavoriteViewsResource,
  tqlExplainerResource,
  directoryActiveViewResource,
];
export const projectDirectoryRouterRoute = projectDirectoryRoute;

// No Workspace Project Directory View
projectNoWorkspaceDirectoryRoute.component = ProjectsEmptyOrNonProvisionedState;
projectNoWorkspaceDirectoryRoute.resources = [titanEapCrossFlowQueryResource];
export const projectNoWorkspaceDirectoryRouterRoute = projectNoWorkspaceDirectoryRoute;

// Following Projects Directory View
const FollowingProjectsDirectoryLoadable = Loadable({
  loader: () => import(/* webpackChunkName: "FollowingProjectsDirectory" */ './components/ProjectDirectory'),
  loading: () => null,
});

projectDirectoryFollowingRoute.component = FollowingProjectsDirectoryLoadable;
projectDirectoryFollowingRoute.resources = [
  onboardingResource,
  projectDirectoryResource,
  projectDirectoryViewResource,
  directoryFavoriteViewsResource,
  tqlExplainerResource,
  directoryActiveViewResource,
];
export const projectDirectoryFollowingRouterRoute = projectDirectoryFollowingRoute;

// Archived Projects Directory View
const ArchivedProjectsDirectoryLoadable = Loadable({
  loader: () => import(/* webpackChunkName: "ArchivedProjectsDirectory" */ './components/ProjectDirectory'),
  loading: () => null,
});

projectDirectoryArchivedRoute.component = ArchivedProjectsDirectoryLoadable;
projectDirectoryArchivedRoute.resources = [
  onboardingResource,
  projectDirectoryResource,
  projectDirectoryViewResource,
  directoryFavoriteViewsResource,
  tqlExplainerResource,
  directoryActiveViewResource,
];
export const projectDirectoryArchivedRouterRoute = projectDirectoryArchivedRoute;
